import React, { useEffect } from 'react'
import { ModalService } from 'services/ModalService'
import WithdrawReadMore from '@bet25/ui/WithdrawReadMore'

const ReadMoreModal = ({ data }) => {
    const readMoreType =
        data.readMoreType && data.readMoreType.type
            ? data.readMoreType.type
            : ''
    return (
        <WithdrawReadMore
            currentTheme={'dark'}
            product={'casinogo'}
            readMoreType={readMoreType}
            onCloseModal={() => {
                ModalService.closeModal('WITHDRAW_READ_MORE')
            }}
        />
    )
}

export default ReadMoreModal
